module.exports = __webpack_public_path__ + "static/media/11.37f4427d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/11.png
// module id = 182
// module chunks = 0